import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import { useState } from "react";
import { Menu } from "lucide-react";

function DashboardLayout({
    role,
    activePage,
    setActivePage,
    children
}) {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const location = useLocation();

    const forceOverlaySidebar = /^\/(admin|user)\/live\/[^/]+$/.test(location.pathname);

    return (
        <div className="flex">
            <Sidebar 
                role={role}
                activePage={activePage}
                setActivePage={setActivePage}
                sidebarOpen={sidebarOpen}
                setSidebarOpen={setSidebarOpen}
                forceOverlay={forceOverlaySidebar}
            />

            {/* <div className="ml-72 flex-1 bg-background min-h-screen">
                <Outlet />
            </div> */}

            <div className={`flex-1 min-w-0 bg-background min-h-screen ${
                forceOverlaySidebar ? "" : "lg:ml-72"
            }`}>
                {/* Mobile Header */}
                <div className={`items-center p-4 border-b bg-deepNavy text-white ${
                    forceOverlaySidebar ? "flex" : "flex lg:hidden"
                }`}>
                    <button onClick={() => setSidebarOpen(true)}>
                        <Menu size={24} />
                    </button>

                    <h1 className="ml-4 font-semibold">
                        LIVEGRID
                    </h1>
                </div>

                <Outlet />
            </div>
        </div>
    )
}

export default DashboardLayout;